module.exports = __webpack_public_path__ + "img/bg_dialog_buy.ee89497a.png";